import { render, staticRenderFns } from "./ScoresBySubjectPolarAreaChart.vue?vue&type=template&id=3f4ee8b5&"
import script from "./ScoresBySubjectPolarAreaChart.vue?vue&type=script&lang=js&"
export * from "./ScoresBySubjectPolarAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports